import { observer } from "mobx-react-lite";
import { FC, useEffect, useState } from "react";
import Video from "./components/video";
import Store from "./store";

const App: FC = observer(() => {

  const [ store ] = useState(() => new Store())
  useEffect(() => store.init(), [ store ])

  return (
    <div>
      <p>Status: {store.peer.status}</p>
      {store.roomInfo && <p>Room uuid: {store.roomInfo.uuid}</p>}
      <p>Watch the console</p>
      <p>Users count: {store.peer.users.size+1}</p>
      <div style={{ display: "flex", width: 300 }}>
        <button onClick={() => store.peer.toggleConstraint("audio")}>
          { store.peer.getConstraint("audio")? "Disable": "Enable" } Microphone
        </button>
        <button onClick={() => store.peer.toggleConstraint("video")}>
          { store.peer.getConstraint("video")? "Disable": "Enable"} WebCam
        </button>
      </div>
      <button onClick={() => store.peer.toggleConstraint("video", "screenSharing") }>
        { store.peer.getConstraint("video", "screenSharing")? "Stop": "Start" } ScreenSharing
      </button>
      <div style={{ display: "flex" }}>
        { Array.from(store.peer.users).map(([ userId, user ]) => user.rawStreams.length > 0 && (
          <div key={userId} style={{ display: "flex", flexDirection: "column" }}>
            { user.rawStreams.map(stream => (
              <Video stream={stream.mediaStream} controls={true} key={stream.streamName} style={{ maxWidth: 400 }}/>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
})

export default App